export default __webpack_public_path__ + "static/media/gameover.679101d2.wav";